import type React from 'react';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { useI18n } from '@change-corgi/core-react/i18n';

export const PhoneImage: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const phoneMockup1x = getStaticAssetUrl('/images/mobile-app-phone-mockup-sunrise-1x.webp');
	const phoneMockup2x = getStaticAssetUrl('/images/mobile-app-phone-mockup-sunrise-2x.webp');

	return (
		<div className="relative top-6 -my-10 h-[211px] w-[217px] overflow-hidden">
			<img
				src={phoneMockup1x}
				srcSet={`${phoneMockup1x} 1x, ${phoneMockup2x} 2x`}
				alt={translate('corgi.app_download.bottom_banner_v2.phone_mockup.image_alt_text')}
			/>
		</div>
	);
};
